import { LINKS } from "@/constants/links.constant";
import type { CustomToastType } from "@components/layout/toast/styled-toast";

export const TOAST_TX_MSG = {
  TX_SUCCESS: {
    toastContent: {
      header: "Transaction successful!",
      message: "Click the link below to view transaction details.",
      status: "success",
    },
    buttonContent: {
      btnLink: `${LINKS.APP.BRIDGE_SCANNER}`, // The implementation appends the transaction hash dynamically
      btnText: "View on Bridge Scanner",
    },
  },
  // When the tx times out but assumes success
  TX_SUCCESS_TIMEOUT: {
    toastContent: {
      header: "Transaction completed!",
      message:
        "The transaction took a bit longer than anticipated, but we believe it was successfully processed.",
      status: "success",
    },
  },
  SIGN_SUCCESS: {
    toastContent: {
      header: "Transaction signed!",
      message: "Check your transaction on the blockchain using the link below.",
      status: "success",
    },
    buttonContent: {
      // Link is dynamically added in the implementation
      btnText: "View Transaction",
    },
  },
  SIGN_ERROR: {
    toastContent: {
      header: "Transaction signing failed!",
      message: "Please try signing the transaction again.",
      status: "error",
    },
  },
  TX_REVERTED: {
    toastContent: {
      header: "Transaction reverted!",
      message: "The transaction could not be processed. Please try again.",
      status: "error",
    },
  },
  TX_TIMEOUT: {
    toastContent: {
      header: "Transaction Timeout!",
      message:
        "Transaction is taking longer than expected. Assuming it succeeded. Please verify the status on the blockchain explorer.",
      status: "warning",
    },
  },
  MAINNET_SLOW_CONFIRMATION: {
    toastContent: {
      header: "Mainnet Confirmation Delay",
      message:
        "Mainnet transactions may take longer to confirm. We're monitoring your transaction and will update you when it's complete.",
      status: "info",
    },
  },
  EXECUTOR_QUOTE_ERROR: {
    toastContent: {
      header: "Quote unavailable",
      message:
        "Could not fetch a Wormhole execution quote. Please try again in a moment.",
      status: "error",
    },
  },
  EXECUTOR_QUOTE_EXPIRED: {
    toastContent: {
      header: "Quote expired",
      message:
        "Your quote expired before submission. Please confirm again to refresh it.",
      status: "warning",
    },
  },
} as const satisfies Record<string, CustomToastType>;

export const TOAST_VALIDATION_MSG = {
  SAME_CHAINS_WARNING: {
    toastContent: {
      header: "Identical chains selected",
      message: "Origin and destination chains must be different",
      status: "warning",
    },
  },
  NO_AMOUNT_ENTERED_WARNING: {
    toastContent: {
      header: "Amount not entered",
      message: "Please enter an amount to bridge",
      status: "warning",
    },
  },
  NO_TOKENS_SELECTED: {
    toastContent: {
      header: "No tokens selected",
      message: "Please select at least one token to bridge",
      status: "warning",
    },
  },
  WALLET_NOT_CONNECTED: {
    toastContent: {
      header: "Wallet not connected",
      message: "Please connect your wallet to continue",
      status: "warning",
    },
  },
  BRIDGE_OUT_NATIVE_ERROR: {
    toastContent: {
      header: "Bridge out not allowed",
      message: "Cannot bridge out to native from Blessnet",
      status: "error",
    },
  },
  BRIDGE_OUT_NATIVE_FROM_BLESSNET_ERROR: {
    toastContent: {
      header: "Bridge out not allowed",
      message: "Cannot bridge out to native from Blessnet",
      status: "error",
    },
  },
  ARB_TO_BLESS_ERROR: {
    toastContent: {
      header: "Invalid quote",
      message: "Cannot retrieve quote between Arbitrum and BlessNet",
      status: "error",
    },
  },
} as const satisfies Record<string, CustomToastType>;
